module.exports = __webpack_public_path__ + "img/genesight_test_sample.b7a0a920.png";